// extracted by mini-css-extract-plugin
module.exports = {"AppFormTag":"AppFormTag_--j4o","AppFormTagSmall":"AppFormTagSmall_WxDZa"};